export default "__VITE_ASSET__5b589242__"